import { useRouter } from "next/router";

const PathName = () => {
  const { asPath } = useRouter();

  if (asPath == "/") {
    var path = "home";
  } else {
    var pathName = asPath.split("/");

    var path = pathName.filter((p) => p != "").join(" ");
  }

  return [path];
};

export default PathName;
